import { render, staticRenderFns } from "./wlsq.vue?vue&type=template&id=77270626&scoped=true&"
import script from "./wlsq.vue?vue&type=script&lang=js&"
export * from "./wlsq.vue?vue&type=script&lang=js&"
import style0 from "./wlsq.vue?vue&type=style&index=0&id=77270626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77270626",
  null
  
)

export default component.exports